import { render } from "./StoreDetails.vue?vue&type=template&id=af77a068&scoped=true"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"

import "./StoreDetails.vue?vue&type=style&index=0&id=af77a068&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af77a068"]])

export default __exports__